import { TypedMutation } from "@saleor/mutations";
import gql from "graphql-tag";

import {
  AnnouncementBulkDelete,
  AnnouncementBulkDeleteVariables
} from "./types/AnnouncementBulkDelete";
import {
  AnnouncementCreate,
  AnnouncementCreateVariables
} from "./types/AnnouncementCreate";
import {
  AnnouncementDelete,
  AnnouncementDeleteVariables
} from "./types/AnnouncementDelete";
import {
  AnnouncementUpdate,
  AnnouncementUpdateVariables
} from "./types/AnnouncementUpdate";

const announcementCreate = gql`
  mutation AnnouncementCreate($input: AnnouncementCreateInput!) {
    announcementCreate(input: $input) {
      errors: announcementError {
        field
        message
        code
      }
      announcement {
        id
        title
      }
    }
  }
`;
export const TypedAnnouncementCreate = TypedMutation<
  AnnouncementCreate,
  AnnouncementCreateVariables
>(announcementCreate);

const announcementUpdate = gql`
  mutation AnnouncementUpdate($id: ID!, $input: AnnouncementCreateInput!) {
    announcementUpdate(id: $id, input: $input) {
      errors: announcementError {
        field
        message
        code
      }
      announcement {
        id
        title
        content
        startDate
        endDate
        publishingStatus
      }
    }
  }
`;
export const TypedAnnouncementUpdate = TypedMutation<
  AnnouncementUpdate,
  AnnouncementUpdateVariables
>(announcementUpdate);

const announcementDelete = gql`
  mutation AnnouncementDelete($id: ID!) {
    announcementDelete(id: $id) {
      errors: announcementError {
        field
        message
      }
    }
  }
`;
export const TypedAnnouncementDelete = TypedMutation<
  AnnouncementDelete,
  AnnouncementDeleteVariables
>(announcementDelete);

const announcementBulkDelete = gql`
  mutation AnnouncementBulkDelete($ids: [ID]!) {
    announcementBulkDelete(ids: $ids) {
      errors {
        field
        message
      }
    }
  }
`;
export const TypedAnnouncementBulkDelete = TypedMutation<
  AnnouncementBulkDelete,
  AnnouncementBulkDeleteVariables
>(announcementBulkDelete);
